<template>
  <div v-cloak class="show-filter">
    <div>
      <input
        v-model="localFilter.searchText"
        type="text"
        placeholder="Search"
        name="searchText"
        @input="debouncedOnChange"
      />
      <button
        type="button"
        class="ui-button"
        :class="{
          'ui-state-active': localFilter && localFilter.genreId == null
        }"
        @click="setGenre(null)"
      >All</button>
      <button
        v-for="genre in genres"
        :key="genre.id"
        type="button"
        class="ui-button"
        :class="{
          'ui-state-active': localFilter && localFilter.genreId == genre.id
        }"
        @click="setGenre(genre.id)"
      >{{ genre.name }}</button>
      <a
        v-show="
          !!localFilter.genreId ||
            !!localFilter.dateFrom ||
            !!localFilter.searchText
        "
        @click="clear"
      >
        <i class="fa fa-times"></i>
      </a>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import _debounce from 'lodash.debounce';
import Service from '@/services/Service.js';
export default {
  data: function() {
    return {
      localFilter: {},
      genres: [],
      minDate: null,
      maxDate: null,
      isHidden: true
    };
  },
  computed: {
    debouncedOnChange() {
      return _debounce(this.setFilter, 700);
    },
    ...mapState(['showFilter'])
  },
  created() {
    this.localFilter = this.showFilter;
    this.getGenres();
  },
  methods: {
    setFilter() {
      this.$store.dispatch('setFilter', this.localFilter);
    },
    clear: function() {
      this.$set(this.localFilter, 'searchText', '');
      this.$set(this.localFilter, 'genreId', null);
      this.$set(this.localFilter, 'dateFrom', null);
      this.$set(this.localFilter, 'dateTo', null);
      this.setFilter();
    },
    setGenre: function(selectedGenreId) {
      this.$set(this.localFilter, 'genreId', selectedGenreId);
      this.setFilter();
    },
    setDate: function(date) {
      this.$set(this.localFilter, 'dateFrom', date);
      this.setFilter();
    },
    getGenres() {
      this.loading = true;
      Service.getGenres()
        .then(response => {
          this.genres = response.data;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    }
  }
};
</script>
